import { useEffect, useState, type ReactNode } from "react";
import "../styles/identity-avatar.css";

/** Identity images are display data; an unavailable image keeps the existing labelled fallback. */
export function IdentityAvatar({ url: value, name = "", className, fallback }: { url?: unknown; name?: string; className: string; fallback?: ReactNode }) {
  const url = typeof value === "string" && /^https?:\/\//.test(value.trim()) ? value.trim() : undefined;
  const [failedUrl, setFailedUrl] = useState<string>();
  useEffect(() => { setFailedUrl(undefined); }, [url]);
  return <span className={`identity-avatar ${className}`} aria-hidden="true">{url && failedUrl !== url
    ? <img key={url} src={url} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setFailedUrl(url)} />
    : fallback ?? (name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(word => Array.from(word)[0]).join("") || "—")}</span>;
}
